import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, LogIn } from "lucide-react";
import portalApi from "../../lib/portalApi";

export default function PortalLogin() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await portalApi.post("/login", { email, password: pw });
      localStorage.setItem("popcrn_portal_token", data.token);
      localStorage.setItem("popcrn_portal_customer", JSON.stringify(data.customer));
      nav("/portal");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f0f10] px-4" data-testid="portal-login">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-1">
          <div className="h-11 w-11 rounded-2xl bg-[var(--pop-yellow,#ffd400)] flex items-center justify-center">
            <ShoppingBag size={22} className="text-black" />
          </div>
          <div>
            <div className="font-black text-xl tracking-tight">POPCRN</div>
            <div className="text-xs uppercase tracking-widest text-neutral-500">Kundenportal</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold mt-6 mb-6">Anmelden</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-semibold text-neutral-700">E-Mail</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                   data-testid="portal-login-email"
                   className="mt-1 w-full rounded-xl border border-neutral-300 px-4 py-3 outline-none focus:border-black" />
          </div>
          <div>
            <label className="text-sm font-semibold text-neutral-700">Passwort</label>
            <input type="password" required value={pw} onChange={(e) => setPw(e.target.value)}
                   data-testid="portal-login-password"
                   className="mt-1 w-full rounded-xl border border-neutral-300 px-4 py-3 outline-none focus:border-black" />
          </div>
          {err && <div className="text-sm text-red-600 font-medium" data-testid="portal-login-error">{err}</div>}
          <button type="submit" disabled={busy} data-testid="portal-login-submit"
                  className="w-full rounded-xl bg-black text-white py-3 font-bold flex items-center justify-center gap-2 hover:bg-neutral-800 disabled:opacity-50">
            <LogIn size={18} /> {busy ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
        <button type="button" onClick={() => nav("/portal/register")} data-testid="portal-register-link"
                className="w-full mt-3 rounded-xl border border-neutral-300 py-3 font-semibold text-neutral-700 hover:bg-neutral-50">
          Neu hier? Jetzt registrieren
        </button>
        <p className="text-xs text-neutral-400 mt-6 text-center">
          Nach der Registrierung prüfen wir Ihre Angaben und schalten den Zugang frei.
        </p>
      </div>
    </div>
  );
}
